export enum Routes {
  LOGIN = "/",
  CREATE_ACCOUNT = "/create-account",
  FORGOT_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",
  VERIFY_EMAIL = "/verify-email",
  CHANGE_PASSWORD = "/change-password",
  DASHBOARD = "/dashboard",
  ADMIN_NOTIFICATIONS = "/dashboard/admin-notifications",
  FEATURED_COLLECTION = "/dashboard/featured-collection",
  FEATURED_COURSES = "/dashboard/featured-courses",
  COURSES_CATEGORY = "/dashboard/course-categories",
  ALL_COURSES = "/dashboard/courses",
  REWARDS = "/dashboard/rewards",
  MANAGE_FEATURED = "/dashboard/featured-collection/manage",
  MANAGE_DRAFT = "/dashboard/manage-draft",
  MANAGE_COLLECTION = "/dashboard/manage-collection",
  MANAGE_COLLECTIONS = "/dashboard/manage-collections",
  MANAGE_DELETED = "/dashboard/manage-deleted",
  TELEGRAM = "/dashboard/telegram",
  TELEGRAM_MESSAGES = "/dashboard/telegram/messages",
  TELEGRAM_MESSAGE = "/dashboard/telegram/send-message",
  SOLO_VERIFICATION = "/dashboard/solo-verification",
  PREVIEW_COLLECTION = "/dashboard/preview-collection",
  CREATE_LAUNCHPAD = "/dashboard/create-launchpad-project",
  MANAGE_LAUNCHPADS = "/dashboard/manage-launchpads",
  MINT_CALENDAR = "/dashboard/mint-calendar",
  MINT_CALENDARS = "/dashboard/mint-calendars",
  DELETE_LISTING = "/dashboard/delete-listing",
  WHITELIST_PARTNER = "/dashboard/whitelist-partner",
  WHITELIST_MANAGEMENT = "/dashboard/whitelist-management",
  BOTS_CONTROL = "/dashboard/bots-control",
  ADD_TELEGRAM_USER = "/dashboard/add-telegram-user",
  USER_MANAGEMENT = "/dashboard/user-management",
}
